import { _ as __rest } from './tslib.es6-b97b9ccd.js';
import React__default from 'react';
import { Indicator as Indicator$1 } from '@mantine/core';
import { theme } from './miscTheme.js';

const Indicator = (_a) => {
    var { styles, color = theme.colors.red700 } = _a, props = __rest(_a, ["styles", "color"]);
    return (React__default.createElement(Indicator$1, Object.assign({ inline: true, position: "top-end", offset: 4, styles: Object.assign({ processing: {
                // FIX: Safari blink
                animationDirection: 'alternate',
            } }, styles), color: color }, props)));
};

export { Indicator as I };
